import type {
  CaseImageVariantForCaseListItem,
  CaseImageVariantListItem,
} from '@messenger/types'

/** Variants keyed by the case image they belong to, newest first per image. */
export type CaseImageVariantsById = Record<string, CaseImageVariantListItem[]>

/**
 * Turn the flat per-case variant list into per-image lists for the grid.
 * The API already orders newest first; that order is kept within each group
 * so the first entry of a group is the newest generation for that image.
 */
export const groupCaseImageVariants = (
  variants: CaseImageVariantForCaseListItem[],
): CaseImageVariantsById => {
  const grouped: CaseImageVariantsById = {}
  for (const variant of variants) {
    const list = grouped[variant.caseImageId] ?? []
    list.push(variant)
    grouped[variant.caseImageId] = list
  }
  return grouped
}
